"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = NavigationLink;

var _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _Icon = _interopRequireDefault(require("../../Icon")),
    _navMenu = require("../styles/navMenu"),
    _Text = _interopRequireDefault(require("../../Text")),
    DEFAULT_ICON_COLOR = "denim";

function getIconColor(a) {
  var b = a.selected,
      c = a.linkColour;
  return c ? c : b ? "darkdenim" : DEFAULT_ICON_COLOR;
}

function NavigationLink(a) {
  var b = a.onClick,
      c = a.icon,
      d = a.label,
      e = a.selected,
      f = a.className,
      g = a.rounded,
      h = a.linkColour,
      i = a.linkHoverColor,
      j = a.linkSelectedColor,
      k = getIconColor({
    selected: e,
    linkColour: h
  }),
      l = "nav-item-".concat(d.replace(/\s/g, "").toLowerCase());
  return _react["default"].createElement("button", {
    id: l,
    "data-cy": l,
    type: "button",
    className: (0, _classnames["default"])((0, _navMenu.MENU_LINK)({
      selected: e,
      rounded: g,
      linkColour: h,
      linkHoverColor: i,
      linkSelectedColor: j
    }), f),
    onClick: b
  }, c ? _react["default"].createElement(_Icon["default"], {
    name: c,
    size: 20,
    color: k
  }) : _react["default"].createElement("div", {
    className: _navMenu.EMPTY_MENU_LINK_ICON
  }), _react["default"].createElement(_Text["default"], {
    noMargin: !0,
    button: !!e
  }, d));
}